module.exports = __webpack_public_path__ + "514c4e96540e75445dc142dddbe2a29a.svg";